import { ReactComponent as Wallet } from "./wallet-icon.svg";

const WalletIcon: React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
> = (props) => <Wallet {...props} />;

export default WalletIcon;
